export default __webpack_public_path__ + "static/media/science_hub_banner3.bb002d4e.png";